module.exports = __webpack_public_path__ + "img/mycart_03.86d24371.png";